import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-connections",
  "use": "icon-connections-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-connections\"><path d=\"M16 6c5.256 0 9.406 3.892 9.902 9H30v2h-4.098c-.496 5.108-4.646 9-9.902 9-2.8 0-5.2-1-7.2-2.8l1.4-1.4c1.6 1.4 3.6 2.2 5.8 2.2 4.4 0 8-3.6 8-8s-3.6-8-8-8c-2 0-4.2.8-5.6 2.4L8.8 8.8C10.8 7 13.4 6 16 6m0 5c2.8 0 5 2.2 5 5s-2.2 5-5 5c-2.4 0-4.4-1.8-4.8-4H2v-2h9.2c.4-2.2 2.4-4 4.8-4m0 2c-1.6 0-3 1.4-3 3s1.4 3 3 3 3-1.4 3-3-1.4-3-3-3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol